"use strict";

import User from "/js/core/user"
import UserLesson from "/js/core/user-lesson"
import UserLessons from "/js/core/user-lessons"
import Global from "/js/core/global";

/**
 * Makes the service calls.
 * Assumes the existence of "Window.gapi".
 */
export default class ServiceUtil {

  static #BASE_URL = "https://primer-api.appspot.com/_ah/api/primer/v1/";
  static #gapiUser = null;
  static #idToken = null;
  static #signInCallback = null;

  /**
   * Does the following in sequence:
   * - Signs in user if necessary.
   * - Gets (or gets created) the database User object.
   * - Gets the user's lesson data.
   * - Calls back.
   */
  static doSignInFlow(isAlreadySignedIn, callback) {

    cl("ServiceUtil.doSignInFlow()");

    ServiceUtil.#signInCallback = callback;
    if (isAlreadySignedIn) {
      ServiceUtil.#doSignInFlowContinued();
      return;
    }
    gapi.auth2.getAuthInstance().signIn().then(() => {
      ServiceUtil.#doSignInFlowContinued();
    }).catch(e => {
      cl(e);
      ServiceUtil.#signInCallback(false);
    });
  }

  static #doSignInFlowContinued() {
    ServiceUtil.#gapiUser = gapi.auth2.getAuthInstance().currentUser.get();
    ServiceUtil.#idToken = ServiceUtil.#gapiUser.getAuthResponse().id_token;
    ServiceUtil.#doCreateOrGetPrimerUser();
  }

  static #doCreateOrGetPrimerUser() {
    const email = ServiceUtil.#gapiUser.getBasicProfile().getEmail();
    const name = ServiceUtil.#gapiUser.getBasicProfile().getName();
    const imageUrl = ServiceUtil.#gapiUser.getBasicProfile().getImageUrl();
    const o = {"email": email, "display_name": name, "image": imageUrl};

    ServiceUtil.#doXhr("user/create-user", "POST", o, (resultObject => {
      if (!resultObject) {
        ServiceUtil.#signInCallback(null);
        return;
      }
      const user = User.fromJsonObject(resultObject);
      if (!user) {
        clw("ERROR: couldn't create User from response object", o);
        ServiceUtil.#signInCallback(null);
        return;
      }
      Global.user = user;
      cl('ServiceUtil.doCreateOrGetPrimerUser()', Global.user.cid, user);
      ServiceUtil.#doGetLessons();
    }));
  }

  static #doGetLessons() {
    const path = `user/lessons?owner_id=${Global.user.cid}`;
    this.#doXhr(path, "GET", null, (resultObject) => {

      if (!resultObject) {
        // TODO: Should this be treated as a 'success', since we already have the user?
        ServiceUtil.#signInCallback(null);
        return;
      }

      // Populate UserLessons with the data.
      let debugInfo = "\r\n";
      for (const item of resultObject.items) {
        const userLesson = UserLesson.fromServerObject(item);
        if (userLesson == null) {
          continue;
        }
        UserLessons.add(userLesson);
        // Store the data locally as well.
        // TODO: How to handle all this for now, anyway?
        UserLessons.saveByLessonId(userLesson.lessonId);
        debugInfo += `${userLesson.lessonId}\r\n${JSON.stringify(userLesson.asServerObject())}\r\n`;
      }

      cl('ServiceUtil.doGetLessons()', UserLessons.map);
      // cl(debugInfo);
      ServiceUtil.#signInCallback(true);
    });
  }

  // TODO: Dirty detection maybe
  static updateUserLesson(userLesson, callback=null) {
    //cl("ServiceUtil.updateUserLesson()");

    const path = `user/${Global.user.cid}/lesson/${userLesson.lessonId}/update`;
    this.#doXhr(path, "POST", userLesson.asServerObject(), resultObject => {
      if (!resultObject) {
        if (callback) {
          callback(null);
        }
        return;
      }
      // cl("ServiceUtil.updateUserLesson()", resultObject);
      if (callback) {
        callback(true);
      }
    });
  }

  /**
   * Sends requests to the server.
   *
   * @param path
   * @param methodName - `GET` or `POST`
   * @param payloadObject - optional data to send, which will be stringified.
   * @param callback - returns JSON-parsed object, or null (request error or parse error).
   */
  static #doXhr(path, methodName, payloadObject=null, callback) {

    const xhr = new XMLHttpRequest();
    const url = ServiceUtil.#BASE_URL + path;
    xhr.open(methodName, url);
    xhr.setRequestHeader('Authorization', `Bearer ${encodeURIComponent(ServiceUtil.#idToken)}` );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onreadystatechange = function () {
      if (this.readyState === XMLHttpRequest.DONE) {
        if (this.status !== 200) {
          cl("doXhr() - ERROR:", this.status, url, methodName);
          callback(null);
          return;
        }
        let o;
        try {
          o = JSON.parse(xhr.responseText);
        } catch (e) {
          cl("doXhr() - ERROR parsing responseText as JSON: ", e);
          callback(null);
          return;
        }
        callback(o);
      }
    };

    let string = payloadObject ? JSON.stringify(payloadObject) : null;
    if (string) {
      xhr.send(string);
    } else {
      xhr.send();
    }
  }
}
